// import React from "react";
import PropTypes from "prop-types";
// import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";

import withModal from "../withModal";
import FlowExportEdit from "../../flows/item/FlowExportEdit";
import FlowItemErrorBox from "../../flows/item/Shared/FlowItemErrorBox";
import MaterialModal from "../MaterialModal";
import { a11yProps } from "../../material-components/Misc/TabPanel";
// import Pagination from "react-bootstrap/lib/Pagination";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

const FlowMultiExportEditModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();

    const [selectedTab, setSelectedTab] = useState<number | null>(null);

    const hide = () => {
        setSelectedTab(null);
        dispatch(hideModal("FLOW_MULTIEXPORT_MODAL"));
    };

    if (!modalProps) {
        return null;
    }

    if (!isOpen && selectedTab != null) {
        setSelectedTab(null);
    }

    if (selectedTab == null && modalProps != null && modalProps.flowItemId != null) {
        setSelectedTab(modalProps.destinations.findIndex(a => a.value == modalProps.flowItemId));
    }

    const theseDestinations = modalProps.destinations || [];
    return (
        <MaterialModal
            isOpen={isOpen}
            onClose={hide}
            id="flow-visible-variables"
            maxWidth="lg"
            fullWidth={true}
            showPrimaryButton={false}
            cancelButtonText="Close"
        >
            {/* <div> */}
            {theseDestinations != null && theseDestinations && (
                <Tabs
                    value={selectedTab}
                    onChange={(_, newValue) => setSelectedTab(newValue as number)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                >
                    {theseDestinations
                        .filter(x => x.isSelected)
                        .map(z => (
                            <Tab
                                key={z.value}
                                style={{ fontSize: 12 }}
                                label={z.destination.item.CompanyName}
                                {...a11yProps(0)}
                            />
                        ))}
                </Tabs>
            )}

            {theseDestinations != null && theseDestinations && (
                <div>
                    {theseDestinations
                        .filter(x => x.isSelected)
                        .map((z, index) => (
                            <div
                                key={z.value}
                                // index={z.value}
                                hidden={selectedTab != index}
                                style={{ paddingLeft: "75px", paddingRight: "75px", paddingBottom: "35px" }}
                            >
                                {" "}
                                <FlowItemErrorBox id={z.value} />
                                <FlowExportEdit
                                    key={z.value + "export"}
                                    flowItemId={z.value}
                                    isModal={true}
                                    hideExtra={false}
                                />
                            </div>
                        ))}
                </div>
            )}
        </MaterialModal>
    );
};

FlowMultiExportEditModal.propTypes = {
    modalProps: PropTypes.any,
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

export default withModal(FlowMultiExportEditModal, "FLOW_MULTIEXPORT_MODAL");
